import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgOtpInputComponent } from 'ng-otp-input/lib/components/ng-otp-input/ng-otp-input.component';
import { CountdownEvent } from 'ngx-countdown';

@Component({
  selector: 'app-sms-otp-verification',
  templateUrl: './sms-otp-verification.component.html',
  styleUrls: ['./sms-otp-verification.component.scss'],
})
export class SmsOtpVerificationComponent implements OnInit, AfterViewInit {
  @Input() maskedMobileNumber: string = '';
  @Input() isError: boolean = false;
  @Output() handleOTPSubmit = new EventEmitter<string>();
  @Output() handleOTPResend = new EventEmitter<any>();
  otpExpire: boolean = false;
  otpExpiryInSeconds: number = 60;
  currentOTPEntry = '';
  otpInputs: HTMLElement[] = []; // Consists of the individual otp input. There should be 6 inputs
  numberOfInputs = 6;

  @ViewChild('ngOtpInput') ngOtpInputRef: NgOtpInputComponent | null = null; //Get reference using ViewChild and the specified hash

  // @Input() length: 6;

  constructor(public activeModal: NgbActiveModal, private el: ElementRef) {}

  ngOnInit(): void {
    console.log('[SmsOtpVerificationComponent] Page OnInit');
  }

  ngAfterViewInit() {
    console.log('[SmsOtpVerificationComponent] Page AfterViewInit');
    for (let i = 0; i < this.numberOfInputs; i++) {
      const otpInput = this.el.nativeElement.querySelector(
        `.fna-otp-input-wrapper .fna-otp-input:nth-child(${i + 1})`,
      );

      this.otpInputs.push(otpInput);
    }

    this.updateInputsDisabledState();

    if (this.ngOtpInputRef) {
      // Override onKeyUp function to achieve pressing backspace/delete behaviour to remove last character of the input value
      // instead of just focus to the previous input
      const self = this;
      this.ngOtpInputRef.onKeyUp = function ($event: any, inputIdx: number) {
        const nextInputId = this.appendKey(`otp_${inputIdx + 1}`);
        const prevInputId = this.appendKey(`otp_${inputIdx - 1}`);
        if (this.ifRightArrow($event)) {
          this.setSelected(nextInputId);
          return;
        }
        if (this.ifLeftArrow($event)) {
          this.setSelected(prevInputId);
          return;
        }
        const isBackspace = this.ifBackspaceOrDelete($event);

        // Original code:
        // if (isBackspace && !$event.target.value) {
        // Overridden code:
        if (isBackspace) {
          this.setSelected(prevInputId);
          // Original code:
          // this.rebuildValue();

          // Overridden code:
          const newValue = self.currentOTPEntry.slice(0, -1); // remove last character
          this.setValue(newValue);
          return;
        }
        if (!$event.target.value) {
          return;
        }
        if (this.ifValidEntry($event)) {
          this.setSelected(nextInputId);
        }
        this.rebuildValue();
      };
    }
  }

  submitOTP() {
   
    this.handleOTPSubmit.emit(this.currentOTPEntry);
    console.log('[SmsOtpVerificationComponent] submitOTP emit');
    this.clearOTP();
  }

  onOtpChange(enteredOtp: string) {
    // console.log('NG OTP Event Value: ', enteredOtp);
    this.currentOTPEntry = enteredOtp;

    this.updateInputsDisabledState();

    if (enteredOtp.length <= 5) {
      let id = this.ngOtpInputRef?.appendKey(`otp_${enteredOtp.length}`);
      this.ngOtpInputRef?.focusTo(id);
    }
  }

  resendOTP() {
    console.log('Resend OTP!');
    this.clearOTP();
    this.handleOTPResend.emit();
  }

  handleCountdownTimer(e: CountdownEvent) {
    console.log('handleCountdownTimer: ', e);
    if (e.action === 'done') {
      this.otpExpire = true;
    } else if (e.action === 'start') {
      this.otpExpire = false;
    }
  }

  clearOTP() {
    this.ngOtpInputRef?.setValue(''); // clear OTP input value
  }

  updateInputsDisabledState() {
    // Set input to disabled to prevent user from clicking
    // Only enable the previous and current input
    const previousIndex = this.currentOTPEntry.length - 1;
    const currentIndex = this.currentOTPEntry.length;

    this.otpInputs.forEach((input, index) => {
      if (index === previousIndex || index === currentIndex) {
        input.removeAttribute('disabled');
      } else {
        input.setAttribute('disabled', 'disabled');
      }
    });
  }

  get otpWrapperClass() {
    const otpWrapperClass = [];
    if (this.currentOTPEntry.length >= 1) {
      otpWrapperClass.push('otp-wrapper-length-1');
    }
    if (this.currentOTPEntry.length >= 2) {
      otpWrapperClass.push('otp-wrapper-length-2');
    }
    if (this.currentOTPEntry.length >= 3) {
      otpWrapperClass.push('otp-wrapper-length-3');
    }
    if (this.currentOTPEntry.length >= 4) {
      otpWrapperClass.push('otp-wrapper-length-4');
    }
    if (this.currentOTPEntry.length >= 5) {
      otpWrapperClass.push('otp-wrapper-length-5');
    }
    if (this.currentOTPEntry.length >= 6) {
      otpWrapperClass.push('otp-wrapper-length-6');
    }
    return otpWrapperClass.join(' ');
  }

  get isCTAEnabled() {
    return this.currentOTPEntry.length >= 6;
  }
}
